import api from '@/lib/api/axios'
import type { TechnologyCategory } from '@/types/entities'

export const categoriesApi = {
    list: () => api.get<TechnologyCategory[]>('/api/categories'),
    get: (id: number) => api.get<TechnologyCategory>(`/api/categories/${id}`),
    create: (data: { name: string }) =>
        api.post<TechnologyCategory>('/api/categories', data),
    update: (id: number, data: { name: string }) =>
        api.put<TechnologyCategory>(`/api/categories/${id}`, data),
    delete: (id: number) => api.delete<{ id: number }>(`/api/categories/${id}`),
}
